import { Redirect, usePathname } from 'expo-router';
import * as React from 'react';
import { ActivityIndicator, View } from 'react-native';

import { requiredReleaseFeaturesForPathname } from '@/lib/features';
import { useReleaseFeatureAccess } from '@/lib/use-release-feature-flag';

export function ReleaseFeatureRouteGuard({
  children,
}: Readonly<{ children: React.ReactNode }>): React.JSX.Element {
  const pathname = usePathname();
  const requiredFeatures = React.useMemo(
    () => requiredReleaseFeaturesForPathname(pathname),
    [pathname]
  );
  const isAllowed = useReleaseFeatureAccess(requiredFeatures);

  if (isAllowed === undefined) {
    return (
      <View className="flex-1 items-center justify-center bg-background">
        <ActivityIndicator />
      </View>
    );
  }

  if (!isAllowed) {
    return <Redirect href={pathname.startsWith('/admin') ? '/admin' : '/app'} />;
  }

  return <>{children}</>;
}
